











import {
  defineComponent,
  ref,
  useFetch,
  useContext,
  onMounted,
} from '@nuxtjs/composition-api';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useContent } from '~/composables';
import type { CmsPage } from '~/modules/GraphQL/types';
import { usePageStore } from '~/stores/page';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { genericPageView } from '~/helpers/trackings/24orepro/pages';
import PageLoading from '~/components/GlobalComponents/PageLoading.vue';
import ClientOnly from 'vue-client-only';
export default defineComponent({
  name: 'CmsPage',
  components: {
    HTMLContent,
    PageLoading,
    ClientOnly
  },
  setup() {
    const { routeData } = usePageStore();
    const { addTags } = useCache();
    const { error: nuxtError } = useContext();
    // @ts-ignore
    const twReady = ref<Boolean>(false)
    const {
      loadPage,
      loading,
      error,
    } = useContent();

    const page = ref<CmsPage | null>(null);

    useFetch(async () => {
      page.value = await loadPage({ identifier: routeData.identifier });

      if (error?.value?.page || !page.value) nuxtError({ statusCode: 404 });

      addTags([{ prefix: CacheTagPrefix.View, value: routeData.identifier }]);
      await genericPageView(routeData.identifier);
    });
    onMounted(() => {
      const twInterval = setInterval(() => {
        // @ts-ignore
        twReady.value = window && !!window.tailwind
        if (!!twReady.value) clearInterval(twInterval)
      }, 10)
    })
    return {
      twReady,
      page,
      loading,
    };
  },
  head() {
    return getMetaInfo(this.page);
  },
});
